<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu"></div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">月度对账</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>标题</span>
            <el-input type="text" class="input" v-model="Query.Title" size="mini"></el-input>
            <span>对账年度</span>
            <el-input type="number" class="input" v-model="Query.Year" size="mini"></el-input>
            <span>对账月度</span>
            <el-input type="number" class="input" v-model="Query.Month" size="mini"></el-input>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="reconciliationList" style="width: 100%; height: 98%" :height="760">
            <el-table-column prop="Title" label="标题"></el-table-column>
            <el-table-column prop="Year" label="对账年份"></el-table-column>
            <el-table-column prop="Month" label="对账月份"></el-table-column>
            <el-table-column prop="CurrentStep" label="状态"></el-table-column>
            <el-table-column prop="CreateDate" label="对账日期"></el-table-column>
            <el-table-column prop="ReconciliationFee" label="对账金额"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="btn_wrap">
                  <el-button type="text" class="btn" size="small" @click="fnEdit(scope.row.ReconciliationId)" v-if="scope.row.CurrentStepNum == 1"> 修改 </el-button>
                  <el-button type="text" class="btn" size="small" @click="fnDelete(scope.row.ReconciliationId)" v-if="scope.row.CurrentStepNum == 1"> 删除 </el-button>
                  <el-button type="text" class="btn" size="small" @click="fnCaSeal(scope.row.ReconciliationId, scope.row.Title, scope.row.FileId)" v-if="scope.row.CurrentStepNum == 3">
                    盖章确认</el-button
                  >
                  <el-button type="text" class="btn" size="small" @click="fnExport(scope.row.FileId, scope.row.Title)" v-if="scope.row.CurrentStepNum > 3"> 导出对账单</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: [],
      Query: {
        Title: '',
        Year: '',
        Month: ''
      },
      reconciliationList: []
    }
  },
  mounted() {
    this.fnGetData()
    window.addEventListener('storage', (e) => {
      let that = this
      if (e.key == 'reconciliationList') {
        localStorage.removeItem('reconciliationList')
        that.fnGetData()
      }
    })
  },
  methods: {
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/Order/ReconciliationList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.reconciliationList = res.data.reconciliationList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnEdit(reconciliationId) {
      let routerData = this.$router.resolve({
        path: '/Reconciliation',
        query: {
          orderId: '',
          reconciliationId: reconciliationId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnDelete(reconciliationId) {
      let config = {
        params: {
          reconciliationId: reconciliationId
        }
      }
      this.$confirm('是否删除此对账单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getRequest('/Order/DeleteReconciliation', config)
          .then((res) => {
            if (res.data.errcode == 0) {
              this.fnGetData()
            } else {
              this.$message.error(res.data.errmsg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    fnCaSeal(OrderId, OrderNumber, FileId) {
      let routerData = this.$router.resolve({
        name: 'ReconciliationCASeal',
        query: {
          OrderId: OrderId,
          OrderNumber: OrderNumber,
          FileId: FileId,
          type: 'Reconciliation'
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnExport(fileId, FileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Order/DownLoadReconciliationFile?FileId=' + fileId + '&fileName=' + FileName
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>

<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.btn_2 {
  float: right;
  border-radius: 6px;
  margin-top: 4px;
  margin-right: 5px;
}
</style>